import React__default from 'react';
import { CSSLength, ndsFontReset, getDataAttributes } from 'nicollet-react-utilities';
import styled from 'styled-components';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/* @define utilities */

/**
 * Take in any number of CSS length string/numbers and return them as CSSLength
 * objects (or undefined)
 * TODO: move this to static method on CSSLength, so you can:
 *   CSSLength.map(['24px', '1em', '4in'])
 * @param {Array} values
 * @returns {?CSSLength}
 */

var cssLengths = function cssLengths(values) {
  return values.map(function (value) {
    return value !== undefined ? new CSSLength(value) : undefined;
  });
};
/**
 * Given an object containing 'width', 'height', or both, as CSS length strings
 * or numbers (which are assumed to be in pixels), calculate the icon's aspect
 * ratio and the return a proper size object with the missing values filled in.
 * @param {{ width: (number|string|String), height: (number|string|String)}} dimensions
 * @param {object} svgMetadata
 * @returns {object}
 */


var aspectSize = function aspectSize(_ref, svgMetadata) {
  var width = _ref.width,
      height = _ref.height;

  var _cssLengths = cssLengths([width, height]),
      _cssLengths2 = _slicedToArray(_cssLengths, 2),
      cssWidth = _cssLengths2[0],
      cssHeight = _cssLengths2[1];

  var aspect = svgMetadata.width / svgMetadata.height; // If we've got just a width, calculate height.
  // If we've got just a height, calculate width.

  if (width !== undefined && height === undefined) {
    return {
      width: cssWidth.toString(),
      height: cssWidth.dividedBy(aspect)
    };
  }

  if (height !== undefined && width === undefined) {
    return {
      width: cssHeight.times(aspect),
      height: cssHeight.toString()
    };
  } // Otherwise, both are defined, so just return those (shrug)


  return {
    width: cssWidth.cssValue,
    height: cssHeight.cssValue
  };
};
/**
 * Take the rotate and/or flip prop and use it to generate the correct CSS
 * transform rule declaration or return undefined which tells Styled Components
 * to not create a rule.
 *
 * @param {?number} rotate
 * @param {?enum} flip
 * @returns {string|undefined}
 */


var generateTransformRule = function generateTransformRule(rotate, flip) {
  var flipMap = {
    horizontal: 'scaleX(-1)',
    vertical: 'scaleY(-1)',
    both: 'scaleX(-1) scaleY(-1)'
  };
  var rotateValue = rotate && "rotate(".concat(rotate, "deg)");
  var flipValue = flip && flip; // only rotate

  if (rotate !== undefined && flip === undefined) {
    return "transform: ".concat(rotateValue, ";");
  } // only flip


  if (rotate === undefined && flip !== undefined) {
    return "transform: ".concat(flipMap[flipValue], ";");
  } // do both


  if (rotate !== undefined && flip !== undefined) {
    return "transform: ".concat(rotateValue, " ").concat(flipMap[flipValue], ";");
  } // tell Styled Components to ignore


  return undefined;
};

var generateDimensions = function generateDimensions(width, height, size, svgMetadata) {
  var dimensions; // provides default dimensions if no width, height or size is defined

  if (svgMetadata !== undefined) {
    dimensions = {
      height: "".concat(svgMetadata.height, "px"),
      width: "".concat(svgMetadata.width, "px")
    };
  }

  if (size !== undefined) {
    dimensions = aspectSize({
      width: size
    }, svgMetadata);
  }

  if (height !== undefined) {
    dimensions = aspectSize({
      height: height
    }, svgMetadata);
  }

  if (width !== undefined) {
    dimensions = aspectSize({
      width: width
    }, svgMetadata);
  }

  return "\n      width: ".concat(dimensions.width, ";\n      height: ").concat(dimensions.height, ";\n    ");
};

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: inline-block;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  left: 0.1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex-shrink:0;\n  color: ", ";\n  fill: ", ";\n  /* transform rule */\n  ", "\n  /* height and width rules */\n  ", "\n  ", "\n  ", "\n\n  svg {\n    display: block;\n    height: 100%;\n    width: 100%;\n\n    @media screen and (-ms-high-contrast: active) {\n      /* Accessibility for high contrast settings, to amplify icon contrast. */\n      /* The !important rules here are permissible only because this is a hard override */\n      fill: white !important; /* ndsTokens.colors.palette.white */\n      stroke: none !important;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var IconWrapper = styled.span(_templateObject(), function (_ref) {
  var fill = _ref.fill;
  return fill;
}, function (_ref2) {
  var fill = _ref2.fill;
  return fill;
}, function (_ref3) {
  var rotate = _ref3.rotate,
      flip = _ref3.flip;
  return generateTransformRule(rotate, flip);
}, function (_ref4) {
  var width = _ref4.width,
      height = _ref4.height,
      size = _ref4.size,
      svgMetadata = _ref4.svgMetadata;
  return generateDimensions(width, height, size, svgMetadata);
}, function (_ref5) {
  var invert = _ref5.invert;
  return invert && 'filter: invert(100%);';
}, ndsFontReset());
var ScreenReaderOnly = styled.span(_templateObject2());
var SvgWrapper = styled.div(_templateObject3());

var Icon = function Icon(props) {
  var className = props.className,
      fill = props.fill,
      flip = props.flip,
      height = props.height,
      invert = props.invert,
      rotate = props.rotate,
      screenReaderText = props.screenReaderText,
      size = props.size,
      style = props.style,
      svgData = props.svgData,
      svgMetadata = props.svgMetadata,
      width = props.width,
      wrapperAs = props.wrapperAs;
  return /*#__PURE__*/React__default.createElement(IconWrapper, _extends({
    className: className,
    "data-icon-name": svgMetadata.id // Please refer to the "fill" PropType comment below for more details about svgMetadata.fills[0]!
    ,
    fill: fill || svgMetadata.fills[0],
    flip: flip,
    height: height,
    invert: invert,
    rotate: rotate,
    size: size,
    style: style,
    svgMetadata: svgMetadata,
    width: width
  }, getDataAttributes(props)), screenReaderText && /*#__PURE__*/React__default.createElement(ScreenReaderOnly, {
    focusable: true
  }, screenReaderText || "icon"), /*#__PURE__*/React__default.createElement(SvgWrapper, {
    as: wrapperAs,
    dangerouslySetInnerHTML: {
      __html: svgData
    }
  }));
};

Icon.displayName = 'Icon';

export { Icon as I, _taggedTemplateLiteral as _ };
